/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * Role Type
 */
export enum RoleType {
    Actor = 'Actor',
    Speaker = 'Speaker',
    Narrator = 'Narrator',
    Announcer = 'Announcer',
    Singer = 'Singer',
    SpecialtyDancer = 'Specialty Dancer',
    SpecialtyAct = 'Specialty Act',
    Puppeteer = 'Puppeteer',
    StuntPerformer = 'Stunt Performer',
    StuntCoordinator = 'Stunt Coordinator',
    Pilot = 'Pilot',
    Clown = 'Clown',
    StandIn = 'Stand In',
    HandModel = 'Hand Model',
    HandModelDoubleScale = 'Hand Model Double Scale',
    Other = 'Other',
    LeaderArrangerComposer = 'Leader Arranger Composer',
    CopyistSideMusician = 'Copyist Side Musician',
    CopyistSideMusician1Double = 'Copyist Side Musician 1 Double',
    CopyistSideMusician2Doubles = 'Copyist Side Musician 2 Doubles',
    CopyistSideMusician3Doubles = 'Copyist Side Musician 3 Doubles',
    CopyistSideMusician4Doubles = 'Copyist Side Musician 4 Doubles',
}
